import { createContext, useCallback, useContext, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const SummaryTypeContext = createContext();

const VALID_MODES = ['detailed', 'simple'];
const DEFAULT_MODE = 'detailed';

export function SummaryTypeProvider({ children }) {
    const [searchParams, setSearchParams] = useSearchParams();

    const summaryType = useMemo(() => {
        const mode = searchParams.get('mode');
        return VALID_MODES.includes(mode) ? mode : DEFAULT_MODE;
    }, [searchParams]);

    const setSummaryType = useCallback(
        newType => {
            if (!VALID_MODES.includes(newType)) return;

            setSearchParams(
                prev => {
                    if (newType === DEFAULT_MODE) {
                        prev.delete('mode');
                    } else {
                        prev.set('mode', newType);
                    }
                    return prev;
                },
                { replace: true }
            );
        },
        [setSearchParams]
    );

    const value = useMemo(() => ({ summaryType, setSummaryType }), [summaryType, setSummaryType]);

    return <SummaryTypeContext.Provider value={value}>{children}</SummaryTypeContext.Provider>;
}

export function useSummaryType() {
    const context = useContext(SummaryTypeContext);
    if (!context) {
        throw new Error('useSummaryType must be used within a SummaryTypeProvider');
    }
    return context;
}

export default SummaryTypeContext;
